<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__brand">
        <div class="footer__wordmark">rights<span class="footer__dot">.</span>tokyo</div>
        <p class="footer__addr">
          東京ライツサービス株式会社<br>
          〒151-0053 東京都渋谷区代々木1-30-14<br>
          <a href="mailto:info@rights.tokyo" class="footer__link">info@rights.tokyo</a>
        </p>
      </div>

      <div class="footer__existing">
        <p class="footer__existing-label">既にご利用の方はこちら</p>
        <a href="https://monstrs.rights.tokyo" target="_blank" rel="noopener noreferrer" aria-label="monstrs にログイン（新しいタブで開きます）" class="footer__monstrs">
          monstrs ログイン <i class="fas fa-arrow-up-right-from-square" aria-hidden="true"></i>
        </a>
        <p class="footer__support">
          <a href="mailto:support@monstrs.rights.tokyo" class="footer__link footer__link--mute">support@monstrs.rights.tokyo</a>
        </p>
      </div>
    </div>
    <p class="footer__copy">© 2026 Tokyo Rights Service Inc.</p>
  </footer>
</template>

<script>
export default { name: 'SiteFooter' }
</script>

<style scoped>
.footer {
  background: var(--ink);
  padding: 40px 24px 28px;
}

.footer__inner {
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
  text-align: left;
}

.footer__wordmark {
  font-family: var(--font-lat);
  font-weight: 700;
  font-size: 20px;
  color: #fff;
  margin-bottom: 10px;
}

.footer__dot {
  color: var(--brand-pink);
}

.footer__addr {
  font-size: 12px;
  color: #b8b6c0;
  line-height: 1.9;
}

.footer__existing {
  text-align: right;
}

.footer__existing-label {
  font-size: 12px;
  color: #8a8894;
  margin-bottom: 8px;
}

.footer__monstrs {
  display: inline-block;
  font-family: var(--font-lat);
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.12);
  padding: 8px 18px;
  border-radius: var(--radius-pill);
}

.footer__monstrs:hover {
  background: rgba(255, 255, 255, 0.2);
}

.footer__support {
  font-size: 11px;
  margin-top: 8px;
}

.footer__link {
  color: var(--brand-pink);
  text-decoration: none;
}

.footer__link--mute {
  color: #8a8894;
}

.footer__copy {
  font-family: var(--font-lat);
  font-size: 11px;
  color: #6a6874;
  text-align: center;
  margin-top: 24px;
}

@media (max-width: 768px) {
  .footer__inner {
    flex-direction: column;
  }

  .footer__existing {
    text-align: left;
  }
}
</style>
